import React, { useState } from 'react';
import { Form, Button, Col, Row, Spinner } from 'react-bootstrap';
import NavHeader from './NavHeader';
import { postData, postDataLogin } from '../ApiServices/ApiService';
import UserNav from '../Users/UserNav';
import { useNavigate, useLocation } from 'react-router-dom';
import LoginNavLoginPage from './LoginNav_LoginPage';

const UserRegistration = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        email: '',
        phoneNumber: '',
        countryCode: '+1',
        linkedIn: '',
        skills: '',
        resume: null,
        resumeFileName: '',
        exam_level:'beginner'
    });

    const [errors, setErrors] = useState({});
    const [resumeLoading, setResumeLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');
    const [fileStatus, setFileStatus] = useState(null);
    const [showSubmit, setShowSubmit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resumeFileName, setResumeFileName] = useState('');
    const [resumeext, setResumeExt] = useState('');
    const [resume, setResume] = useState('')
    const [filePath, setFilePath] = useState('')
    const [regError, setRegError] = useState('')


    // Handle input changes
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const numberChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle resume upload logic
    const uploadResume = async (event) => {
        setErrors('');
        setResumeLoading(true);
        const file = event.target.files[0];

        if (!file) {
            setResumeLoading(false);
            console.log('No file selected');
            return;
        }

        // const fileSize = file.size; // Size of the file in bytes
        // console.log("File size:", fileSize, "bytes");
        // if (fileSize > 100 * 1024) {
        //     setSuccess("Max File Allowed 100 KB.");
        //     setFileStatus("0"); // Set file status to 1 (failed)
        //     return false;
        // }

        const fileSize = file.size; // Size of the file in bytes
        console.log("File size:", fileSize, "bytes");
        if (fileSize > 5 * 1024 * 1024) { // 5MB in bytes
            setErrors("Max File Allowed 5 MB.");
            setResumeLoading(false);
            setFileStatus("0"); // Set file status to 1 (failed)
            return false;
        }

        const randomSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
        const timestamp = new Date().getTime(); // Get current timestamp
        const uniqueId = `${randomSixDigitNumber}.${timestamp}`;; // Create a unique ID
        const fileName = `${uniqueId}.${file.name.split('.').pop()}`;
        const fileNameWithoutExtension = `${uniqueId}`; // Add the unique ID to the file name
        setResumeFileName(fileNameWithoutExtension);

        const fileExtension = fileName.split('.').pop().toLowerCase();
        console.log("File extension:", fileExtension);
        setResumeExt(fileExtension);
        const allowedExtensions = ['pdf', 'doc', 'docx']
        if (!allowedExtensions.includes(fileExtension)) {
            setErrors("Only Valid Images are allowed pdf,doc,docx,");
            setResumeLoading(false);
            setFileStatus("0"); // Set file status to 1 (failed)
            return false;
        }

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result.split(',')[1];
                console.log("base64Image", base64Image);
                setResume(base64Image);
                console.log("resume", resume);
                setFileStatus("1"); // Set file status to 0 (success)

                const fileNameWithoutExtension = fileName.replace(/\.[^/.]+$/, ""); // Removes the extension
                console.log(fileNameWithoutExtension);
                setResumeLoading(false);
                setSuccessMsg('Resume Uploaded Successfully');
                return

                const payload = {
                    "resume_data": base64Image,
                    "resume_ext": fileExtension,
                    "file_name": fileNameWithoutExtension,
                };

                try {
                    postData('admin_in/upload-resume', payload).then(resp => {
                        resp.json().then(respData => {
                            if (resp.status === 200) {
                                if (respData.statusCode === 200) {
                                    if (respData.message.toLowerCase() === 'success') {
                                        if (respData.dataJ.length > 0) {
                                            setFilePath(respData.dataJ[0])
                                            setShowSubmit(true);
                                            setLoading(false)
                                            setResumeLoading(false);
                                            setSuccessMsg("Resume Uploaded Successfully");
                                        } else {
                                            setLoading(false);
                                            setErrors(resp.info);
                                            setResumeLoading(false);
                                        }
                                    } else {
                                        setLoading(false);
                                        setErrors(resp.info);
                                        setResumeLoading(false);
                                    }

                                } else if (respData.statusCode === 500) {
                                    setLoading(false);
                                    setErrors(resp.info);
                                    setResumeLoading(false);
                                } else {
                                    setLoading(false);
                                    setErrors(resp.info);
                                    setResumeLoading(false);
                                }
                            }
                            else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
                                console.log('resp status else if : ', resp.status);
                                setLoading(false)
                                if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                                    || respData.message === 'Access Denied') {
                                    setLoading(false);
                                    setResumeLoading(false);
                                }
                            } else {
                                console.log('resp status else  : ', resp);
                                setLoading(false);
                                setResumeLoading(false);
                            }
                        }).catch((error) => {
                            console.log('network error:', error);
                            setLoading(false);
                            setResumeLoading(false);
                        });
                    }).catch((error) => {
                        setLoading(false)
                        setLoading(false);
                        setResumeLoading(false);
                        console.log('network error:', error);
                    });
                } catch (error) {
                    setLoading(false)
                    setResumeLoading(false);
                    setErrors('Upload Resume Failed. Please check your credentials or Network Error!');
                    console.error('Job Details failed', error);
                }
            };
            reader.readAsDataURL(file);
        } else {
            console.log('No file selected');
            setFileStatus("0"); // Set file status to 1 (failed)
        }
    };

    // Reset form
    const handleReset = () => {
        setFormData({
            firstName: '',
            lastName: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            email: '',
            phoneNumber: '',
            countryCode: '+1',
            linkedIn: '',
            skills: '',
            resume: null,
            resumeFileName: '',
            exam_level:'beginner'
        });
        setErrors({});
        setSuccessMsg('');
        setFileStatus(null);
    };

    // Validate form
    const validateForm = () => {
        let formErrors = {};
        if (!formData.firstName) formErrors.firstName = 'First Name is required';
        if (!formData.lastName) formErrors.lastName = 'Last Name is required';
        if (!formData.email) formErrors.email = 'Email is required';
        // if (!formData.linkedIn) formErrors.linkedIn = 'LinkedIn Profile URL is required';
        if (!formData.skills) formErrors.skills = 'This box is mandatory';
        // if (!formData.resume) formErrors.resume = 'Resume is required';
        return formErrors;
    };

    // Handle form submit
    const handleSubmit = (e) => {
        setSuccessMsg('')
        setErrors('')
        e.preventDefault();
        const formErrors = validateForm();
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
        } else {
            console.log('Form submitted successfully with data:', formData);
            // return
            setLoading(true);

            const payload = {
                "first_name": formData.firstName,
                "last_name": formData.lastName,
                "city": formData.city,
                "email_id": formData.email,
                "country_code": formData.countryCode,
                "phone": formData.phoneNumber,
                "linkedin_url": formData.linkedIn,
                "skills": formData.skills,
                "resume_file_path": filePath,
                "resume_data": resume,
                "resume_ext": resumeext,
                "file_name": resumeFileName,
                "exam_level":formData.exam_level
            }

            // return
            try {
                postDataLogin('demo-test/de-tst-otp-gen', payload).then(respData => {

                    if (respData.statusCode === 200) {
                        if (respData.message.toLowerCase() === 'success') {
                            setLoading(false);
                            setSuccessMsg(respData.info);
                            const user_id = respData?.data?.user_id
                            const test_id = respData?.data?.test_id
                            setTimeout(() => {
                                navigate(`/otp-verify?email_id=${formData.email}&user_id=${user_id}&test_id=${test_id}`)
                            }, 2000)
                            setFormData({
                                firstName: '',
                                lastName: '',
                                city: '',
                                state: '',
                                zip: '',
                                country: '',
                                email: '',
                                phoneNumber: '',
                                countryCode: '+1',
                                linkedIn: '',
                                skills: '',
                                resume: null,
                                resumeFileName: '',
                                exam_level:'beginner'
                            })
                            setFileStatus("0");
                            setResumeFileName('');
                            setResumeExt('');
                            setFilePath('')




                        } else {
                            setLoading(false);
                            setRegError(respData?.info);
                        }

                    } else if (respData.statusCode === 500) {
                        setLoading(false);
                        setRegError(respData?.info);
                    } else {
                        setLoading(false);
                        setRegError('Login Failed. Please check your credentials.');
                    }
                }).catch((error) => {
                    setRegError('Network Error');
                    console.log('network error:', error);
                    setLoading(false);
                });

            } catch (error) {
                setLoading(false);
                // Handle login error, e.g., display an error message to the user.
                console.error('Login failed', error);
            }

        }
    };

    return (
        <div className='dashboard-div'>
            <LoginNavLoginPage></LoginNavLoginPage>

            <h2 className='login-heading'><span style={{ color: 'blue' }}>Engage</span>Talent.AI - User Registration</h2>

            <div className='add-job-div'>
                <div className="candidate-div" style={{ maxWidth: 700 }}>
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <Form.Group controlId="formFirstName" className="mb-3">
                                    <Form.Control
                                        type="text"
                                        name="firstName"
                                        placeholder="First Name*"
                                        value={formData.firstName}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.firstName}
                                    />
                                    <Form.Control.Feedback type="invalid">Please Enter A First Name.</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formLastName" className="mb-3">
                                    <Form.Control
                                        type="text"
                                        name="lastName"
                                        placeholder="Last Name*"
                                        value={formData.lastName}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.lastName}
                                    />
                                    <Form.Control.Feedback type="invalid">Please Enter A Last Name.</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group controlId="formCityStateZip" className="mb-3">
                            <Form.Control
                                type="text"
                                name="city"
                                placeholder="City, State, Zip, Country"
                                value={formData.city}
                                onChange={handleInputChange}
                            />
                        </Form.Group>

                        <Row>
                            <Col md={6}>
                                <Form.Group controlId="formEmail" className="mb-3">
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        placeholder="Email ID*"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.email}
                                    />
                                    <Form.Control.Feedback type="invalid">Please Enter A Email.</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group controlId="formPhoneNumber" className="mb-3">
                                    <Row>
                                        <Col xs={4}>
                                            <Form.Control
                                                as="select"
                                                name="countryCode"
                                                value={formData.countryCode}
                                                onChange={handleInputChange}
                                            >
                                                <option value="+1">+1 (USA)</option>
                                                <option value="+91">+91 (India)</option>
                                                <option value="+52">+52 (Mexico)</option>
                                            </Form.Control>
                                        </Col>
                                        <Col xs={8}>
                                            <Form.Control
                                                type="text"
                                                name="phoneNumber"
                                                placeholder="Phone Number"
                                                value={formData.phoneNumber}
                                                onChange={numberChange}
                                                maxLength={10}
                                            />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Form.Group controlId="formLinkedIn" className="mb-3">
                            <Form.Control
                                type="text"
                                name="linkedIn"
                                placeholder="LinkedIn Profile URL"
                                value={formData.linkedIn}
                                onChange={handleInputChange}
                                isInvalid={!!errors.linkedIn}
                            />
                            <Form.Control.Feedback type="invalid">Please Enter A LinkedIn Profile URL.</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group controlId="formAreas" className="mb-3">
                            <Form.Control
                                as="textarea"
                                name="skills"
                                placeholder="Areas you like to get tested on (OR). Technologies you like to get tested on (OR). Please copy-paste your Job Description. --- This Field is mandatory."
                                value={formData.skills}
                                onChange={handleInputChange}
                                isInvalid={!!errors.skills}
                                style={{textTransform:'capitalize'}}
                            />
                            <Form.Control.Feedback type="invalid">Please Enter A Technology Or Job Description.</Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group controlId="formExamLevel" style={{ marginBottom: '10px' }}>
              <Row> 
                <Col xs={6} style={{ paddingRight: '0px' }}>
                  <Form.Select
                    as="select"
                    name="exam_level"
                    value={formData.exam_level}
                    onChange={handleInputChange}
                    required
                    style={{ width: '100%' }}
                  >
                    {/* Options for  exam levels */}
                    {/* <option value="testlevel">Testlevel for Client Questions </option> */}
                    <option value="beginner">Beginner </option>
                    <option value="intermediate">Intermediate</option>
                    <option value="experienced">Experienced</option>

                  </Form.Select>
                  <Form.Control.Feedback type="invalid">Please Select a Exam level.</Form.Control.Feedback>
                </Col>
              
              </Row>

            </Form.Group>

                        <Form.Group controlId="formResume" className="mb-3">
                            <Row>
                                <Col md={6}>
                                    <Form.Control
                                        type="text"
                                        name="upload resume"
                                        placeholder="Upload Resume"
                                        value={formData.resumeFileName}
                                        disabled
                                        style={{ marginBottom: 10 }}

                                    />
                                </Col>
                                <Col md={6} className='d-flex justify-content-center align-items-center'>
                                    <label htmlFor="file-input" className="file-input-label" style={{ marginRight: '10px', width: '40%', textAlign: 'center' }}>
                                        {resumeLoading && <Spinner animation="border" size="sm" />}
                                        {resumeLoading ? 'Uploading' : 'Upload'}
                                    </label>
                                    <input
                                        id="file-input"
                                        type="file"
                                        accept=".pdf,.doc,.docx"
                                        onChange={uploadResume}
                                        style={{ display: 'none' }}
                                        disabled={resumeLoading}
                                    />
                                    {/* {formData.resumeFileName && (
                                    <span>{formData.resumeFileName}</span>
                                )} */}
                                    {errors.resume && formData.resumeFileName === '' && (
                                        <div className="text-danger" style={{textTransform:'capitalize'}}>{errors.resume}</div>  // Show error message if resume is not uploaded
                                    )}
                                </Col>
                            </Row>

                        </Form.Group>

                        <div className="d-flex justify-content-center mt-4">
                            {loading && (
                                <div className="spinner-overlay">
                                    <Spinner animation="border" role="status">
                                        <span className="sr-only"></span>
                                    </Spinner>
                                </div>
                            )}
                            <Button
                                type="submit"
                                variant="primary"
                                className="custom-submit-button"
                                style={{ backgroundColor: '#0056b3', color: '#fff', marginRight: '10px', width: '30%' }}
                            >
                                Submit
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={handleReset}
                                className="custom-reset-button"
                                style={{ backgroundColor: '#0056b3', color: '#fff', width: '30%' }}
                            >
                                Reset
                            </Button>
                        </div>
                        {successMsg && <div className="text-success" style={{ textAlign: 'center', paddingTop: 5,textTransform:'capitalize' }}>{successMsg}</div>}
                        {regError && <div className="text-danger" style={{ textAlign: 'center', paddingTop: 5,textTransform:'capitalize' }}>{regError}</div>}
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default UserRegistration;
